module.exports = __webpack_public_path__ + "img/img-placeholder.1a900a04.svg";